import { cn } from "@devhop/ui";

export type OrderDetailSummaryLine = {
  key: string;
  label: string;
  amount: number;
  variant?: "default" | "discount";
};

type OrderDetailSummaryProps = {
  subtotal: number;
  taxTotal: number;
  serviceChargeTotal: number;
  discountTotal?: number;
  discountLines?: OrderDetailSummaryLine[];
  grandTotal: number;
  className?: string;
};

export function OrderDetailSummary({
  subtotal,
  taxTotal,
  serviceChargeTotal,
  discountTotal = 0,
  discountLines,
  grandTotal,
  className,
}: OrderDetailSummaryProps) {
  return (
    <div className={cn("rounded-xl border bg-card p-4 shadow-sm", className)}>
      <h3 className="mb-3 font-heading font-semibold text-base">ລາຄາລວມ</h3>
      <div className="space-y-2 text-sm">
        <SummaryRow label="ລາຄາຍ່ອຍ" amount={subtotal} />
        <SummaryRow label="ພາສີ" amount={taxTotal} />
        <SummaryRow label="ຄ່າບໍລິການ" amount={serviceChargeTotal} />

        {discountLines && discountLines.length > 0
          ? discountLines.map((line) => (
              <SummaryRow
                key={line.key}
                label={line.label}
                amount={line.amount}
                variant="discount"
              />
            ))
          : discountTotal > 0 && (
              <SummaryRow
                label="ສ່ວນຫຼຸດ"
                amount={discountTotal}
                variant="discount"
              />
            )}

        <div className="flex items-center justify-between border-t pt-3">
          <span className="font-semibold text-base">ລວມທັງໝົດ</span>
          <span className="font-heading font-bold text-2xl text-primary tabular-nums">
            {grandTotal.toLocaleString("lo-LA")} ₭
          </span>
        </div>
      </div>
    </div>
  );
}

function SummaryRow({
  label,
  amount,
  variant = "default",
}: {
  label: string;
  amount: number;
  variant?: "default" | "discount";
}) {
  const isDiscount = variant === "discount";
  return (
    <div className="flex items-center justify-between gap-2">
      <span className="text-muted-foreground">{label}</span>
      <span
        className={cn(
          "font-medium tabular-nums",
          isDiscount && "text-emerald-600 dark:text-emerald-400",
        )}
      >
        {isDiscount ? "-" : ""}
        {amount.toLocaleString("lo-LA")} ₭
      </span>
    </div>
  );
}
